import React from "react";
import Header from "../components/HeaderBlock/Header";

import Hero from "../components/HeroBlock/Hero";
import Side from "../components/Side";

const Main = () => {
  return (
    <>
      <Header />
      <Side />
      <Hero />
    </>
  );
};

export default Main;
